import React from 'react';

const Gallery = () => (
  <div className="pt-24 pb-16 container-custom px-4">
    <h1 className="text-3xl sm:text-4xl font-display font-bold text-night mb-8">Smile Gallery</h1>
    <div className="bg-slate rounded-2xl p-12 text-center"><p className="text-gray-500">Gallery page coming soon...</p></div>
  </div>
);

export default Gallery;
